export const volumesState = (state) => state.volumes;
export const getLoadingVolumes= (state) => volumesState(state).loading;
export const getResponseVolumes = (state) => volumesState(state).response;